const AUTO_LOGIN_TOKEN_PARAM = 'autoLoginToken';
const TOKEN_RESPONSE_KEYS = ['token', 'autoLoginToken'];
const URL_RESPONSE_KEYS = ['redirectTo', 'magicLink', 'loginUrl'];

const hasAbsoluteScheme = (value) => /^[a-z][a-z0-9+.-]*:/i.test(value);

const getWindowOrigin = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://botspot.trade';
};

const getUrlValue = (response, fallbackUrl = '/') => {
  for (const key of URL_RESPONSE_KEYS) {
    if (typeof response?.[key] === 'string' && response[key].trim()) {
      return response[key].trim();
    }
  }
  return fallbackUrl;
};

const parseUrl = (value) => {
  if (typeof value !== 'string' || !value.trim() || value.trim().startsWith('//')) {
    return null;
  }

  try {
    return new URL(value.trim(), getWindowOrigin());
  } catch (_error) {
    return null;
  }
};

export const getStripeAutoLoginToken = (response) => {
  for (const key of TOKEN_RESPONSE_KEYS) {
    if (typeof response?.[key] === 'string' && response[key].trim()) {
      return response[key].trim();
    }
  }

  for (const key of URL_RESPONSE_KEYS) {
    const parsed = parseUrl(response?.[key]);
    const token = parsed?.searchParams.get(AUTO_LOGIN_TOKEN_PARAM);
    if (token) {
      return token;
    }
  }

  return null;
};

export const getTokenlessStripeAutoLoginUrl = (response, fallbackUrl = '/') => {
  const rawUrl = getUrlValue(response, fallbackUrl);
  const parsed = parseUrl(rawUrl);
  if (!parsed) {
    return fallbackUrl;
  }

  parsed.searchParams.delete(AUTO_LOGIN_TOKEN_PARAM);

  if (!hasAbsoluteScheme(rawUrl)) {
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  }

  return parsed.toString();
};

export const completeStripeAutoLogin = async (
  response,
  {
    handleCustomJwtAuth,
    fallbackUrl = '/',
    navigate,
    replace = true,
  } = {},
) => {
  if (!response?.success || response.method !== 'seamless_auto_login') {
    return false;
  }

  const token = getStripeAutoLoginToken(response);
  const targetUrl = getTokenlessStripeAutoLoginUrl(response, fallbackUrl);

  if (token && typeof handleCustomJwtAuth === 'function') {
    await handleCustomJwtAuth(token);
  }

  if (typeof navigate === 'function' && targetUrl.startsWith('/')) {
    navigate(targetUrl, { replace });
  } else if (typeof window !== 'undefined') {
    window.location.href = targetUrl;
  }

  return true;
};
